export default "__VITE_ASSET__6bf53052__"